<div class="carbon-modal-overlay" [class.active]="active"
    (click)="!disableClose && closeModal()">
    <div class="carbon-modal-content"
        [class.carbon-modal-content--overflow-visible]="contentOverflowVisible"
        (click)="$event.stopPropagation()">
        <div class="carbon-modal-header">
            <div class="carbon-modal-title">
                <h3>{{ title }}</h3>
            </div>
            <button *ngIf="!disableClose" class="carbon-modal-close-button"
                (click)="closeModal()" type="button">
                <svg width="20" height="20" viewBox="0 0 16 16"
                    fill="currentColor">
                    <path
                        d="M8 8.707l3.646 3.647.708-.707L8.707 8l3.647-3.646-.707-.708L8 7.293 4.354 3.646l-.707.708L7.293 8l-3.646 3.646.707.708L8 8.707z" />
                </svg>
            </button>
        </div>
        <div class="carbon-modal-body" [class.custom-content]="customContent">
            <!-- Conteúdo padrão (mensagem) -->
            <div *ngIf="!customContent" [innerHTML]="safeMessage"></div>

            <!-- Conteúdo customizado (ng-content) -->
            <ng-content *ngIf="customContent"></ng-content>
        </div>
        <div class="carbon-modal-footer"
            [class.three-buttons]="hasMiddleButton && hasCancelButton"
            [class.two-buttons]="hasMiddleButton && !hasCancelButton">
            <button *ngIf="hasCancelButton"
                class="carbon-button carbon-button--cancel" (click)="onCancel()"
                [disabled]="loading">
                {{ cancelText }}
            </button>

            <button *ngIf="hasMiddleButton"
                class="carbon-button carbon-button--middle" (click)="onMiddle()"
                [disabled]="loading">
                {{ middleText }}
            </button>

            <div *ngIf="hasCancelButton || hasMiddleButton"
                class="carbon-button-separator"></div>
            <button class="carbon-button carbon-button--confirm"
                (click)="onConfirm()" [disabled]="loading || disableConfirm">
                {{ confirmText }}
            </button>
        </div>
    </div>
</div>